import styled from 'styled-components';

import { Button } from '../../Button';

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
`;
